import { Pipe, PipeTransform } from '@angular/core';
import { stringFormatter } from './stringFormatter';

@Pipe({ name: 'cpf_cnpj_mask' })
export class CpfCnpjMaskDirective implements PipeTransform {

    transform(originalValue: string, ...args: any[]): string {

        if (!originalValue || originalValue.length === 0) {
            return '';
        }

        const numberString = stringFormatter.toOnlyPositiveTruncatedNumberString(originalValue);

        if (numberString.length <= 11) {
            const cpfFormatado = this.formatarCpf(numberString);
            return cpfFormatado;
        }

        const cnpjFormatado = this.formatarCnpj(numberString);
        return cnpjFormatado;
    }

    private formatarCpf(numberString: string): string {

        // Coloca um ponto entre o terceiro e o quarto dígitos
        const valorPrimeiraFormatacao = numberString.replace(/(\d{3})(\d)/, '$1.$2');

        // Coloca um ponto entre o terceiro e o quarto dígitos
        // de novo (para o segundo bloco de números)
        const valorSegundaFormatacao = valorPrimeiraFormatacao.replace(/(\d{3})(\d)/, '$1.$2');

        // Coloca um hífen entre o terceiro e o quarto dígitos
        const valorTerceiraFormatacao = valorSegundaFormatacao.replace(/(\d{3})(\d{1,2})$/, '$1-$2');

        return valorTerceiraFormatacao;
    }

    private formatarCnpj(numberString: string): string {

        // Adicionando o ponto entre o segundo e terceiro digito
        const valorPrimeiraFormatacao = numberString.replace(/(\d{2})(\d)/, '$1.$2');

        // Adicionando o ponto entre o quinto e sexto digito
        const valorSegundaFormatacao = valorPrimeiraFormatacao.replace(/(\d{3})(\d)/, '$1.$2');

        // Adicionando a barra entre o oitavo e nono digito
        const valorTerceiraFormatacao = valorSegundaFormatacao.replace(/(\d{3})(\d)/, '$1/$2');

        // Adicionando o hifen entre o decimo segundo e decimo terceiro digito
        const valorQuartaFormatacao = valorTerceiraFormatacao.replace(/(\d{4})(\d)/, '$1-$2');

        return valorQuartaFormatacao;
    }
}



// WEBPACK FOOTER //
// ./src/app/util/cpf_cnpj-mask.ts